module.exports = __webpack_public_path__ + "static/Vazir-Bold-98819aab10beb4b168833db6f235e4af.woff";